/**
 * ======================================
 * F O R M   V A L U E S  (filters)
 * ======================================
 */

export type FormValuesBalanceReport = {
  playerId: string
  startDate: string
  endDate: string
}

/**
 * ======================================
 * I N I T I A L   V A L U E S
 * ======================================
 */

export const initialValuesBalanceReport: FormValuesBalanceReport = {
  playerId: '',
  startDate: null,
  endDate: null,
}
